import { useEffect } from 'react';
import { isProduction } from '~/src/params';

const CONTAINER_ID = '019720f6-bf36-70ab-913d-ec316cb7712f';

export function useInitMtsAnalytics() {
    useEffect(() => {
        if (!isProduction) {
            return;
        }

        const script = document.createElement('script');
        script.src = `https://tag.a.mts.ru/container/${CONTAINER_ID}/tag.js`;
        script.async = true;
        document.body.append(script);
    }, []);
}
